/* jshint esnext: true */

const controls = {

	scene: null,

	directions: {
		'U': [ 'y', '-=' + settings.tileWidth ],
		'R': [ 'x', '+=' + settings.tileWidth ],
		'D': [ 'y', '+=' + settings.tileWidth ],
		'L': [ 'x', '-=' + settings.tileWidth ],
	},

	cursors: null,

	currentDirection: '',

	tween: null,

	myCursors: {
		'down': {},
		'up': {},
		'left': {},
		'right': {}
	},

	inverseDirections: {
		'U': 'D',
		'D': 'U',
		'L': 'R',
		'R': 'L'
	},


	/**
	 * Initialize all the things.
	 * Requires the scene property so that the settings get added to the correct
	 * thing.
	 */
	init: function( scene ) {

		this.scene = scene;

		this.currentDirection = '';

		this.cursors = this.scene.input.keyboard.createCursorKeys();

		// console.log( 'swipe pointer', game.device.input.touch, this.scene.input.activePointer );

		//  Touch?
		if ( game.device.input.touch ) {

			this.scene.input.once(
				'pointerdown',
				function( pointer ) {

					// console.log( pointer );

					this.addSwipe( pointer );

				},
				this
			);

		} else {

			this.addSwipe( this.scene.input.activePointer );

		}

	},


	addSwipe: function( pointer ) {

		new controlsSwipe( this.scene, pointer );

		this.scene.input.on(
			'swipeup',
			function() {
				this.addMove( 'U' );
			},
			this
		);

		this.scene.input.on(
			'swiperight',
			function() {
				this.addMove( 'R' );
			},
			this
		);

		this.scene.input.on(
			'swipedown',
			function() {
				this.addMove( 'D' );
			},
			this
		);

		this.scene.input.on(
			'swipeleft',
			function() {
				this.addMove( 'L' );
			},
			this
		);


	},


	/**
	 * Update the controls.
	 */
	update: function() {

		/**
		 * Check for key presses and then add a new movement to the cue.
		 */
		if ( this.myCursors.up.press ) {
			this.addMove( 'U' );
		}
		if ( this.myCursors.right.press ) {
			this.addMove( 'R' );
		}
		if ( this.myCursors.down.press ) {
			this.addMove( 'D' );
		}
		if ( this.myCursors.left.press ) {
			this.addMove( 'L' );
		}

		/**
		 * Every update check to see if there is a move and if so perform the
		 * required movement.
		 */
		this.move();


		/**
		 * Update the cursor settings. Adds features that are missing from
		 * Phaser core. Specifically press and release.
		 */
		this.updateMyCursor( 'up' );
		this.updateMyCursor( 'right' );
		this.updateMyCursor( 'down' );
		this.updateMyCursor( 'left' );

	},


	/**
	 * Update the cursor data to store keypresses, and releases.
	 */
	updateMyCursor: function( direction = null ) {

		if ( !direction ) {
			return;
		}

		this.myCursors[ direction ] = {
			'old': this.cursors[ direction ].isDown,
			'release': this.myCursors[ direction ].old && !this.cursors[ direction ].isDown,
			'press': !this.myCursors[ direction ].old && this.cursors[ direction ].isDown
		};

	},


	/**
	 * Add a character movement.
	 */
	addMove: function( direction ) {

		moves.add( direction );

		/**
		 * Start the game.
		 * Has to be placed after the move has been added since it resets the
		 * movements. We don't want the movement to be stored.
		 */
		gameplay.start();

		return;

	},


	/**
	 * Move the player around the board.
	 */
	move: function() {

		if ( this.tween ) {
			return;
		}

		if ( 'play' !== gameplay.state ) {
			return;
		}

		let direction = this.getNextDirection();
		let character = gameCharacter.character;

		// Only move if there's a direction.
		if ( !direction ) {
			gameCharacter.setAnimation();
			return;
		}

		/**
		 * Can I move in current direction?
		 * If not call the move function again and then quit
		 * If so then nove in the specified direction.
		 */
		this.tween = this.scene.tweens.add(
			{
				targets: character,
				// ...this.directions[ direction ],
				[ this.directions[ direction ][ 0 ] ]: this.directions[ direction ][ 1 ],
				ease: 'Linear',
				duration: gameplay.getSpeed(),
				onComplete: () => {
					controls.tween = null;
				},
			}
		);

		if ( 'R' === direction ) {
			gameCharacter.character.setFlipX( false );
		}

		if ( 'L' === direction ) {
			gameCharacter.character.setFlipX( true );
		}

		gameCharacter.setAnimation( direction );

		return direction;

	},


	/**
	 * Reset the current controls.
	 */
	reset: function() {

		if ( this.tween && this.tween.isPlaying() ) {
			this.tween.remove();
		}

	},


	/**
	 * Get the next direction to travel.
	 *
	 * return false to stop the character from walking.
	 */
	getNextDirection: function() {

		// Get the current tile.
		let tile = {
			x: Math.floor( gameCharacter.character.x / settings.tileWidth ),
			y: Math.floor( gameCharacter.character.y / settings.tileWidth ),
		};

		/**
		 * If on the exit tile then go to the next level.
		 */
		if ( tile.x === map.checkpoints.end && tile.y === gameplay.height - 1 ) {

			gameplay.levelComplete();

		}

		/**
		 * If the new direction is opposite to the current direction then swap
		 * at the next opportunity.
		 *
		 * This allows the player to change direction before a junction.
		 */
		if ( moves.move === this.inverseDirections[ controls.currentDirection ] ) {

			controls.currentDirection = moves.next();
			return controls.currentDirection;

		}

		// Get a collection of possible directions for the current tile.
		let directions = Object.values( mazes.directions[ tile.y ][ tile.x ] );

		// Calculate which directions can be moved to automatically.
		let allowedDirections = directions.filter(
			( v ) => {

				return v != this.inverseDirections[ controls.currentDirection ];

			}
		);

		// console.log( this.inverseDirections[ controls.currentDirection ], controls.currentDirection, allowedDirections );
		// If there's only one direction then go that way!
		// if ( allowedDirections.length === 1 && this.inverseDirections[ controls.currentDirection ] === allowedDirections[ 0 ] ) {

		// 	controls.currentDirection = allowedDirections[ 0 ];
		// 	return controls.currentDirection;

		// }

		// If there's only one direction and it's opposite to the current direction then go that way!
		// Works for dead ends.

		// if ( allowedDirections.length === 1 && controls.currentDirection === allowedDirections[ 0 ] ) {

		// 	return controls.currentDirection;

		// }

		/**
		 * If there's no moves, or the next move is not valid, then keep on walking.
		 *
		 * Will still stop if the player can not keep walking in the current direction.
		 */
		if ( !moves.move || !directions.includes( moves.move ) ) {
			if ( directions.includes( controls.currentDirection ) ) {

				return controls.currentDirection;

			}
		}


		// Get the next direction to travel.
		let nextDirection = moves.next();

		controls.currentDirection = '';

		if ( directions.includes( nextDirection ) ) {

			controls.currentDirection = nextDirection;

		}

		return controls.currentDirection;

	}

};
